// @core/api/endpoints/user/get_user.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UserResponse,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Get user by ID
 * Retrieves a user by their unique identifier. Returns the full user profile including all associated metadata and settings.
 */
export async function GetUser(
  id: string,
  options?: RequestOptions
): Promise<UserResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<UserResponse>(requestPath, { ...requestOptions });
}
